import { NotificationsService } from '../services/NotificationsService';
import { moduleMapping } from '../utils/moduleMapping';

const notificationAudio = new Audio('/static/notifications/audio.mp3');

export default class Notifications {
  constructor(Vue) {
    this.company = Vue.prototype.$company;

    this.notificationsPermission = ('Notification' in window) ? Notification.permission : 'denied';
    this.notificationsByModule = {};
    this.generalNotifications = [];
  }

  clear() {
    this.notificationsByModule = {};
    this.generalNotifications = [];
    this.updatePageNotifications();
  }

  setupEmptyNotifications() {
    const availableModules = this.company.json.module;
    const allItens = availableModules.map(m => m.item).flat();

    allItens.forEach(item => {
      this.notificationsByModule[item.id] = [];
    });
  }

  async getNotifications() {
    const [err, notifications] = await NotificationsService.list();
    if (err) return;

    const { notificationsByModule } = this;

    for (const notification of notifications) {
      if (!notification.module) {
        this.generalNotifications = [...this.generalNotifications, notification];
      } else {
        const item = this.getModuleItem(notification.module);

        if (!item) continue;

        if (!notificationsByModule[item.id].length)
          notificationsByModule[item.id] = [];

        notificationsByModule[item.id] = [...notificationsByModule[item.id], notification];
      }
    }

    this.notificationsByModule = notificationsByModule;
    this.updatePageNotifications();
  }

  addNotification(notification) {
    if (!notification.module) {
      this.generalNotifications = [...this.generalNotifications, notification];
    } else {
      const item = this.getModuleItem(notification.module);

      if (!item) return;

      if (!this.notificationsByModule[item.id].length)
        this.notificationsByModule[item.id] = [];

      this.notificationsByModule[item.id] = [...this.notificationsByModule[item.id], notification];
    }

    this.updatePageNotifications();
  }

  removeNotification(notification) {
    if (!notification.module) {
      this.generalNotifications = this.generalNotifications.filter(not => not.identifier !== notification.identifier);
    } else {
      const item = this.getModuleItem(notification.module);

      if (!item) return;

      this.notificationsByModule[item.id] = this.notificationsByModule[item.id].filter(not => not.identifier !== notification.identifier);
    }

    this.updatePageNotifications();
  }

  getNotificationsByModule(module) {
    const item = this.getModuleItem(module);

    if (!item) return [];

    return this.notificationsByModule[item.id];
  }

  async notify({ title, message, notify }) {
    if (!('Notification' in window)) return;

    await Notification.requestPermission(result => {
      this.notificationsPermission = result;
    });

    if (this.notificationsPermission !== 'granted' || !notify) return;

    await Promise.all([
      new Notification(title, {
        body: message,
        silent: true,
      }),
      notificationAudio.play(),
    ]);
  }

  /** @private */
  updatePageNotifications() {
    const allNotifications = [...this.generalNotifications, ...Object.values(this.notificationsByModule).flat()];
    const notificationsCount = allNotifications.reduce((acc, notification) => {
      if (acc.some(not => not.identifier.includes(notification.uniqueIdentifier)) || notification.read) return acc;

      return [...acc, notification];
    }, []).length;

    const title = window.document.title.replace(/ *\([^)]*\) */g, '');
    const titleText = `${
      notificationsCount ? `(${notificationsCount}) ${title}` : title
    }`;

    this.changeFavIcon(
      notificationsCount
        ? '/static/favicon-notification.ico'
        : '/static/favicon.ico',
    );

    window.document.title = titleText;
  }

  /** @private */
  changeFavIcon(favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = favicon;
  }

  /**
   * @private
   *
   * @param {string} module
   */
  getModuleItem(module) {
    const script = moduleMapping(module);

    const availableModules = this.company.json.module;
    const allItens = availableModules.map(m => m.item).flat();
    const item = allItens.find(item => item.script === script);

    return item;
  }
}

